import React, {useCallback, useEffect} from 'react'
import {Button, message, notification, Modal} from 'antd'
import {metaMask, hooks, supportChainIds} from '../../../utils/connectors/metaMask';
import styled from "styled-components";
import MetaMaskIcon from '../../../assets/images/icons/metaMask.png'
// import WalletConnectIcon from '../../../assets/images/icons/WalletConnect.png'
import {useMutation} from 'react-query'
import {getLoginSignDate, walletLogin} from "../../../api/User";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {setToken, setTwoFA, setUser} from "../../../features/user/userSlice";
import {useDispatch} from "react-redux";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const Title = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #4D555D;
`

const LoginButton = styled(Button)`
  border: 1px solid #434343;
  border-radius: 25px;
  width: 264px;
  height: 50px;
  padding-left: 24px;
  margin-top: 22px;
  font-size: 16px;
  text-align: center;
  img {
    margin-right: 15px;
  }
  &:hover,
  &:visited,
  &:focus {
    border-color: #18EAC4;
    color: #18EAC4;
  }
`

const Link = styled.a`
  color: #18EAC4;
  &:hover {
    opacity: 0.8;
  }
`

export const WalletLogin = () => {
  const navigate = useNavigate()
  const account = hooks.useAccount()

  const isActive = hooks.useIsActive()

  const provider = hooks.useProvider()
  window.web3Fly = provider
  const dispatch = useDispatch();
  const [params] = useSearchParams()

  const {mutate: loginSignMutate, data: signData} = useMutation(getLoginSignDate)
  const {mutate: walletLoginMutate, data: walletLoginData} = useMutation(walletLogin)
  const { t } = useTranslation();

  const onMetaMaskLogin = useCallback(() => {
    if (typeof window.ethereum !== 'undefined') {
      if (account) {
        loginSignMutate(account)
      } else {
        metaMask.activate(supportChainIds).catch(err => {
          message.error(err.message)
        })
      }
    } else {
      Modal.warning({
        title: 'Web3 wallet not detected',
        content: (
          <div>
            Please make sure your wallet is unlocked and available. If you do not currently have this wallet, install it in <Link href='https://metamask.io' target='_blank'>metamask.io</Link>.
          </div>
        ),
        okButtonProps: {
          type: 'primary',
          style: {
            backgroundColor: '#18EAC4',
            borderColor: '#18EAC4',
            color: '#000',
            borderRadius: '4px',
          }
        },
        okText: 'Dismiss'
      })
    }
  }, [metaMask, account, loginSignMutate, isActive])

  const signMessage = useCallback(async () => {
    if (signData && provider && account) {
      const sign = signData.data.sign_data
      try {
        const signature = await provider.getSigner().signMessage(sign)
        walletLoginMutate({
          signature,
          address: account
        })
      } catch (err) {
        if (err.code === 'ACTION_REJECTED') {
          message.error('MetaMask Message Signature: User denied message signature.')
        } else {
          message.error(err.reason)
        }
      }
    }
  }, [signData, provider, account])

  useEffect(() => {
    if (isActive) {
      loginSignMutate(account)
    }
  }, [isActive])

  useEffect(() => {
    signMessage().then()
  }, [signData])

  useEffect(() => {
    metaMask.resetState()
  }, [])

  useEffect(() => {
    if (walletLoginData) {
      const {data, code} = walletLoginData
      if (code === '10000') {
        if(data.user.two_fa){
          navigate(`/login/2fa?id=${data.user.id}`);
          return;
        }

        message.success(t('loginPage.message.success')).then();
        if (!data.user.wallet_address && data.user.type !== 1) {
          notification.warning({
            key:'warning',
            message: '',
            description: (
              <span
                style={{
                  fontSize: '16px',
                }}
              >
                  Please set your wallet address before submitting your report.
                </span>
            ),
            duration: 5000,
            btn: (
              <Button
                size="small"
                style={{
                  height: '32px',
                  backgroundColor: '#18EAC4',
                  borderColor: '#18EAC4',
                  color: '#000',
                  borderRadius: '6px',
                }}
                onClick={() => {
                  notification.close('warning');
                  navigate('/user?page=my_info', { state: { wallet_address: true } });
                }}
              >
                Setting
              </Button>
            ),
          });
          setTimeout(() => {
            navigate('/');
          }, 2000);
        }else if(params.get('redirect_url')){
          if(params.get('redirect_url') !== '/login'){
            navigate(params.get('redirect_url'));
          }
          navigate('/');
        }else{
          setTimeout(() => {
            navigate('/');
          }, 2000);
        }

        dispatch(setUser(data));
        dispatch(setToken(`${data.type} ${data.token}`));
        dispatch(setTwoFA(data.user.two_fa));
      } else if (code === '10001') {
        navigate(`/wallet_email_bind?bindKey=${data.email_bind_key}&address=${account}`)
      }
    }
  }, [walletLoginData])

  const onWalletConnect = () => {
    activate(connectors.walletConnect, (error) => {
      if (error) {
        console.error(error)
      }
    }).then()
  }

  return (
    <Wrapper>
      {/*<Title>Login via web3 wallet</Title>*/}
      <LoginButton onClick={onMetaMaskLogin}>
        <img width={30} src={MetaMaskIcon} alt=""/>
        login via MetaMask
      </LoginButton>
      <br />
      {/*<LoginButton onClick={onWalletConnect}>*/}
      {/*  <img width={30} src={WalletConnectIcon} alt=""/>*/}
      {/*  WalletConnect*/}
      {/*</LoginButton>*/}
    </Wrapper>
  )
}
